module.exports = __webpack_public_path__ + "static/media/authenticate-tutorial.b93db98d.png";